/*
 * Shop all grid: merge each 200 mg / 100 mg card pair into one card on the ALL and
 * VARIETY filters.
 *
 * Every pairable card is rendered server-side as today (so EVERYDAY / HIGH OUTPUT
 * are untouched) with data-pair-key, data-strength and a per-card
 * <script type="application/json" class="wip-strength-data">. This script marks the
 * 200 mg card "primary" and the 100 mg card "secondary"; CSS hides the secondary and
 * shows the toggle on the primary only on the ALL and VARIETY filters.
 * The toggle swaps image, strength/pouches text, price, per-pouch price, links and the
 * Add to Cart id.
 *
 * facets.js replaces #ProductGridContainer on every filter change, so state resets
 * and init() runs again (called from <wip-toggle-bar>'s apply()).
 */
(function () {
  'use strict';

  if (window.WipStrengthToggle) return;

  function readData(item) {
    if (item.__wipData !== undefined) return item.__wipData;
    var el = item.querySelector('script.wip-strength-data');
    var data = null;
    if (el) {
      try {
        data = JSON.parse(el.textContent);
      } catch (e) {
        data = null;
      }
    }
    item.__wipData = data;
    return data;
  }

  function select(item, mg) {
    var data = item.__wipVariants && item.__wipVariants[mg];
    if (!data) return;
    var card = item.querySelector('.custom-product-card');
    if (!card) return;

    var img = card.querySelector('img.custom-product-image');
    if (img && data.image) {
      img.src = data.image;
      img.alt = data.alt || img.alt;
    }

    var links = card.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (data.url) links[i].setAttribute('href', data.url);
    }

    var dosage = card.querySelector('.wip-meta-row .dosage');
    if (dosage && data.label) dosage.textContent = data.label;
    var pouches = card.querySelector('.wip-meta-row .pouches');
    if (pouches && data.pouches) pouches.textContent = data.pouches;

    var price = card.querySelector('.wip-card-price');
    if (price && data.price_html) price.innerHTML = data.price_html;
    var perPouch = card.querySelector('.wip-per-pouch');
    if (perPouch && data.per_pouch) perPouch.textContent = data.per_pouch;

    var idInput = card.querySelector('form.wip-add-form input[name="id"]');
    if (idInput) idInput.value = data.id;

    var segs = item.querySelectorAll('.wip-strength-toggle__seg');
    for (var j = 0; j < segs.length; j++) {
      segs[j].setAttribute('aria-pressed', segs[j].getAttribute('data-wip-strength') === mg ? 'true' : 'false');
    }
    item.setAttribute('data-selected-strength', mg);
  }

  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.getAttribute('data-wip-paired') === 'true') return;

    var groups = {};
    var items = grid.querySelectorAll('.grid__item[data-pair-key]');
    for (var i = 0; i < items.length; i++) {
      var key = items[i].getAttribute('data-pair-key');
      var mg = items[i].getAttribute('data-strength');
      if (!key || (mg !== '200' && mg !== '100')) continue;
      groups[key] = groups[key] || {};
      if (!groups[key][mg]) groups[key][mg] = items[i];
    }

    Object.keys(groups).forEach(function (key) {
      var primary = groups[key]['200'];
      var secondary = groups[key]['100'];
      if (!primary || !secondary) return;
      var d200 = readData(primary);
      var d100 = readData(secondary);
      if (!d200 || !d100) return;

      primary.setAttribute('data-pair-role', 'primary');
      secondary.setAttribute('data-pair-role', 'secondary');
      primary.__wipVariants = { 200: d200, 100: d100 };

      var seg200 = primary.querySelector('.wip-strength-toggle__seg[data-wip-strength="200"]');
      var seg100 = primary.querySelector('.wip-strength-toggle__seg[data-wip-strength="100"]');
      var initial = '200';
      if (!d200.available && d100.available) {
        if (seg200) seg200.disabled = true;
        initial = '100';
      } else if (d200.available && !d100.available) {
        if (seg100) seg100.disabled = true;
      }
      select(primary, initial);
    });

    grid.setAttribute('data-wip-paired', 'true');
  }

  // Warm the other strength's image as soon as a finger/pointer lands on the toggle,
  // so the swap on click doesn't show a blank frame on slow mobile connections.
  function preload(e) {
    var seg = e.target && e.target.closest ? e.target.closest('.wip-strength-toggle__seg') : null;
    if (!seg || seg.disabled) return;
    var item = seg.closest('.grid__item[data-pair-role="primary"]');
    var data = item && item.__wipVariants && item.__wipVariants[seg.getAttribute('data-wip-strength')];
    if (!data || !data.image || data.__preloaded) return;
    data.__preloaded = true;
    new Image().src = data.image;
  }
  document.addEventListener('pointerdown', preload, { passive: true });
  document.addEventListener('touchstart', preload, { passive: true });

  document.addEventListener('click', function (e) {
    var seg = e.target && e.target.closest ? e.target.closest('.wip-strength-toggle__seg') : null;
    if (!seg || seg.disabled) return;
    var item = seg.closest('.grid__item[data-pair-role="primary"]');
    if (!item) return;
    e.preventDefault();
    select(item, seg.getAttribute('data-wip-strength'));
  });

  window.WipStrengthToggle = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
